<template>
  <section class="p-0 text-gray-700">
    <div class="header mb-1 mt-2 p-0 md:p-2 ml-8 md:ml-0">
      <h2 class="font-bold text-gray-700 text-xl">
        <i class="bx bxs-truck text-indigo-500 -m-8 mr-1"></i>
        ENDEREÇO DE ENTREGA
      </h2>
      <small class="text-gray-600">Para quem devemos entregar o pedido?</small>
    </div>
    <div class="mb-1 p-0 md:p-2">
      <ValidationProvider rules="required" v-slot="{ errors }">
        <t-input
          name="my-input"
          :variant="errors.length > 0 ? 'danger' : '' "
          v-model="zipcode"
          inputmode="numeric"
          class="w-full md:w-1/2"
          placeholder="CEP:"
          maxlength="9"
          v-mask="'#####-###'"
        />
        <span class="text-red-500 block pt-1" v-if="errors.length">
          <i class="bx bx-error mr-1"></i>
          {{ errors[0] }}
        </span>
      </ValidationProvider>
      <div class="w-full pt-2">
        <small> <a target="_blank" href="http://www.buscacep.correios.com.br/sistemas/buscacep/" class="underline text-gray-600">Não sei meu CEP</a></small>
      </div>
    </div>
    <div class="mb-1 p-0 md:p-2" v-if="show">
      <div class="shadow-2l bg-white w-full rounded border-l-4 border-indigo-500" >
        <div class="flex flex-wrap ">
          <div class="w-full md:w-12/12 md:mb-0 p-4 md:p-4 ">
            <h3 class="text-md font-bold">Endereço</h3>
            <p class="text-sm">Rua: {{ street}}, N° {{ number }} {{ complement }} <br> Bairro: {{ neighborhood }}, Cidade: {{ city}} - {{ uf }}</p>
          </div>
          <div class="w-full md:w-5/12 md:mb-0 p-4 md:p-4 bg-gray-200">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <t-input
                name="address_number"
                :variant="errors.length > 0 ? 'danger' : 'credit' "
                v-model="number"
                class="w-full"
                placeholder="Numero:"
              />
              <span class="text-red-500 block pt-1" v-if="errors.length">
                <i class="bx bx-error mr-1"></i>
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-7/12 md:mb-0 p-0 px-4 py-2 md:p-4 bg-gray-200">
            <t-input
              name="address_complement"
              v-model="complement"
              variant="credit"
              class="w-full"
              placeholder="Complemento:"
            />
            <small class="text-gray-600 text-xs">Ex: BLOCO 3 AP 42</small>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-1" v-if="false">
      <div class="flex flex-wrap">
        <div class="w-full md:w-8/12 mb-1 md:mb-0 p-0 md:p-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <t-input
              name="my-input"
              :variant="errors.length > 0 ? 'danger' : '' "
              v-model="street"
              class="w-full"
              placeholder="Endereço:"
            />
            <span class="text-red-500 block pt-1" v-if="errors.length">
              <i class="bx bx-error mr-1"></i>
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div class="w-full md:w-4/12 mb-1 md:mb-0 p-0 md:p-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <t-input
              name="my-input"
              :variant="errors.length > 0 ? 'danger' : '' "
              v-model="number"
              class="w-full"
              placeholder="Numero:"
            />
            <span class="text-red-500 block pt-1" v-if="errors.length">
              <i class="bx bx-error mr-1"></i>
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div class="w-full md:w-6/12 mb-1 md:mb-0 p-0 md:p-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <t-input
              name="my-input"
              :variant="errors.length > 0 ? 'danger' : '' "
              v-model="neighborhood"
              class="w-full"
              placeholder="Bairro:"
            />
            <span class="text-red-500 block pt-1" v-if="errors.length">
              <i class="bx bx-error mr-1"></i>
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div class="w-full md:w-6/12 mb-1 md:mb-0 p-0 md:p-2">
          <t-input
            name="my-input"
            v-model="complement"
            class="w-full"
            placeholder="Complemento:"
          />
        </div>
        <div class="w-full md:w-6/12 p-0 mb-1 md:mb-0 md:p-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <t-input
              name="my-input"
              :variant="errors.length > 0 ? 'danger' : '' "
              v-model="city"
              class="w-full"
              placeholder="Cidade:"
            />
            <span class="text-red-500 block pt-1" v-if="errors.length">
              <i class="bx bx-error mr-1"></i>
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div class="w-full md:w-6/12 p-0 md:p-2 mb-1 md:mb-0">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <t-input
              name="address_state"
              :variant="errors.length > 0 ? 'danger' : '' "
              v-model="uf"
              class="w-full"
              placeholder="Estado:"
            />
            <span class="text-red-500 block pt-1" v-if="errors.length">
              <i class="bx bx-error mr-1"></i>
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    zipcode: {
      get () {
        return this.$store.state.address_zipcode
      },
      set (newValue) {
        this.$store.commit('ZIPCODE', newValue)
      }
    },
    street: {
      get () {
        return this.$store.state.address_street
      },
      set (newValue) {
        this.$store.commit('STREET', newValue)
      }
    },
    number: {
      get () {
        return this.$store.state.address_number
      },
      set (newValue) {
        this.$store.state.address_number = newValue
      }
    },
    neighborhood: {
      get () {
        return this.$store.state.address_neighborhood
      },
      set (newValue) {
        this.$store.state.address_neighborhood = newValue
      }
    },
    complement: {
      get () {
        return this.$store.state.address_complement
      },
      set (newValue) {
        this.$store.state.address_complement = newValue
      }
    },
    city: {
      get () {
        return this.$store.state.address_city
      },
      set (newValue) {
        this.$store.state.address_city = newValue
      }
    },
    uf: {
      get () {
        return this.$store.state.address_uf
      },
      set (newValue) {
        this.$store.state.address_uf = newValue
      }
    }

  },
  watch: {
    zipcode () {
      if (this.zipcode.length >= 9) {
        this.doAddress()
      } else {
        this.show = false
      }
    }
  },
  methods: {
    doAddress () {
      if (this.zipcode.length === 9) {
        this.$store.dispatch('getAddressByCep', this.zipcode).then((response) => {
          this.show = !this.show
        })
      } else {
        this.show = false
      }
    }
  },
  data () {
    return {
      address_zipcode: '',
      address_street: '',
      address_number: '',
      address_neighborhood: '',
      address_complement: '',
      address_city: '',
      address_state: '',
      show: false,
      states: [
        {
          nome: 'Acre',
          sigla: 'AC'
        },
        {
          nome: 'Alagoas',
          sigla: 'AL'
        },
        {
          nome: 'Amapá',
          sigla: 'AP'
        },
        {
          nome: 'Amazonas',
          sigla: 'AM'
        },
        {
          nome: 'Bahia',
          sigla: 'BA'
        },
        {
          nome: 'Ceará',
          sigla: 'CE'
        },
        {
          nome: 'Distrito Federal',
          sigla: 'DF'
        },
        {
          nome: 'Espírito Santo',
          sigla: 'ES'
        },
        {
          nome: 'Goiás',
          sigla: 'GO'
        },
        {
          nome: 'Maranhão',
          sigla: 'MA'
        },
        {
          nome: 'Mato Grosso',
          sigla: 'MT'
        },
        {
          nome: 'Mato Grosso do Sul',
          sigla: 'MS'
        },
        {
          nome: 'Minas Gerais',
          sigla: 'MG'
        },
        {
          nome: 'Pará',
          sigla: 'PA'
        },
        {
          nome: 'Paraíba',
          sigla: 'PB'
        },
        {
          nome: 'Paraná',
          sigla: 'PR'
        },
        {
          nome: 'Pernambuco',
          sigla: 'PE'
        },
        {
          nome: 'Piauí',
          sigla: 'PI'
        },
        {
          nome: 'Rio de Janeiro',
          sigla: 'RJ'
        },
        {
          nome: 'Rio Grande do Norte',
          sigla: 'RN'
        },
        {
          nome: 'Rio Grande do Sul',
          sigla: 'RS'
        },
        {
          nome: 'Rondônia',
          sigla: 'RO'
        },
        {
          nome: 'Roraima',
          sigla: 'RR'
        },
        {
          nome: 'Santa Catarina',
          sigla: 'SC'
        },
        {
          nome: 'São Paulo',
          sigla: 'SP'
        },
        {
          nome: 'Sergipe',
          sigla: 'SE'
        },
        {
          nome: 'Tocantins',
          sigla: 'TO'
        }
      ]
    }
  }
}
</script>

<style>
</style>
